import initFetchPlants from './modules/fetch-plants';
import initCustomSelectBox from './modules/custom-select-box';
import initScrollToTop from './modules/scroll-to-top';

initCustomSelectBox();
initFetchPlants();
initScrollToTop();
